import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconSettingsCogFill';
/** Renders an SVG icon. */
const SvgSettingsCogFill = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m4.383 8.074 1.424 2.752a11.4 11.4 0 0 0-.673 1.625l-2.955.94-.12 1.321a14 14 0 0 0 0 2.576l.12 1.322 2.955.939a11 11 0 0 0 .673 1.624l-1.424 2.753.848 1.02c.55.662 1.16 1.273 1.823 1.823l1.02.848 2.752-1.424q.781.397 1.625.673l.94 2.955 1.321.12a14 14 0 0 0 2.576 0l1.322-.12.939-2.955c.562-.183 1.105-.41 1.624-.673l2.753 1.424 1.02-.848a14 14 0 0 0 1.823-1.823l.848-1.02-1.424-2.753q.397-.78.673-1.624l2.955-.94.12-1.321a14 14 0 0 0 0-2.576l-.12-1.322-2.955-.94a11.4 11.4 0 0 0-.673-1.623l1.424-2.753-.848-1.02a14 14 0 0 0-1.823-1.823l-1.02-.848-2.753 1.424q-.78-.397-1.624-.673l-.94-2.955-1.321-.12a14 14 0 0 0-2.576 0l-1.322.12-.94 2.955q-.843.276-1.623.673L8.073 4.383l-1.02.848A14 14 0 0 0 5.23 7.054zM22 16a6 6 0 1 1-12 0 6 6 0 0 1 12 0"
      />
    </svg>
  );
};
SvgSettingsCogFill.displayName = displayName;
export default SvgSettingsCogFill;
